export type ThemeColourGroups = 'slate' | 'blue' | 'tomato' | 'grass' | 'amber';

export function scToTwColour(
  accessor: string,
  shouldReturnComputed = false
): string {
  const themeKey = accessor.split('.')[2];

  if (!shouldReturnComputed) return `var(--color-${themeKey})`;

  const styles = getComputedStyle(document.body);
  const color = styles.getPropertyValue(`--color-${themeKey}`);

  return color;
}
